 
import { CenterCellContainer } from "./CenterCell.elements"
import React, { ReactNode } from "react"

export const CenterValues = ({asSVG = false, centerX, centerY, chartTotals, ...props}: Record<string, unknown>): JSX.Element => {
  const { groupKey, valueKey, mapKeys} = props
  const isDefaultView = chartTotals?.isDefaultView ? true : false
  const format = props?.format || {}
  let { title, value, label } = props
 

  value = value || chartTotals?.[valueKey as keyof typeof chartTotals || 'count'] 
  label = label || chartTotals?.[groupKey] 
  
  label = mapKeys?.[label as string] || label
  title = title || mapKeys?.[title as string]

  title = (format?.centerValues?.({ title: title || true, isDefaultView, ...(chartTotals || {}), props}) || title) as ReactNode
  value = (format?.centerValues?.({ value: value || true, isDefaultView, ...(chartTotals || {}), props}) || value) as ReactNode
  label = (format?.centerValues?.({ label: label || true, isDefaultView, ...(chartTotals || {}), props}) || label) as ReactNode

  if (!asSVG) return (
    <CenterCellContainer className='center-values'>
      <div className='title'>{title || ''}</div>
      <div className='value'>{value || ''}</div>
      <div className='label'>{label || ''}</div>
    </CenterCellContainer>
  )

  return (
   <CenterCellContainer transform={`translate(${centerX}, ${centerY})`} as='g'>
      <text className='center-value title'>{title || ''}</text>
      <text className='center-value  value'>{value || ''}</text>
      <text className='center-value  label'>{label || ''}</text>
    </CenterCellContainer>
  )
}